export const validateByLastVersion = require('./02.06')

export const versions = {
  '00.00': () => import(/* webpackChunkName: 'settings-schema-v00-00' */ './00.00'),
  '01.00': () => import(/* webpackChunkName: 'settings-schema-v01-00' */ './01.00'),
  '02.00': () => import(/* webpackChunkName: 'settings-schema-v02-00' */ './02.00'),
  '02.01': () => import(/* webpackChunkName: 'settings-schema-v02-01' */ './02.01'),
  '02.02': () => import(/* webpackChunkName: 'settings-schema-v02-02' */ './02.02'),
  '02.03': () => import(/* webpackChunkName: 'settings-schema-v02-03' */ './02.03'),
  '02.04': () => import(/* webpackChunkName: 'settings-schema-v02-04' */ './02.04'),
  '02.05': () => import(/* webpackChunkName: 'settings-schema-v02-05' */ './02.05'),
  '02.06': () => Promise.resolve(validateByLastVersion)
}
